import { ObservableArray, View } from "binder"
import { ToolValidStatusEditorViewModel } from "./toolValidStatusEditor-viewModel"
import { ToolStatusMultiSelectorViewModel } from "../toolStatusMultiSelector";
import { ToolStatusesViewModel } from "../toolValidStatusManipulation-viewModel";

export class ToolValidStatusEditorView extends View<ToolValidStatusEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-2BBF3E99-9FCF-4ABD-89A2-DD0700547A2C"
    }
    loadHtml(): string {
        let element = require('./toolValidStatusEditor.html').default;
        let style = require('./toolValidStatusEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelCode(v: string) { this._toolModelCode = v; } public get toolModelCode(): string { return this._toolModelCode; } private _toolModelCode: string;
    public set toolStatusSelector(v: ToolStatusMultiSelectorViewModel) { this._toolStatusSelector = v; } public get toolStatusSelector(): ToolStatusMultiSelectorViewModel { return this._toolStatusSelector; } private _toolStatusSelector: ToolStatusMultiSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolStausIds(v: ObservableArray<ToolStatusesViewModel>) { this._toolStausIds = v; } public get toolStausIds(): ObservableArray<ToolStatusesViewModel> { return this._toolStausIds; } private _toolStausIds: ObservableArray<ToolStatusesViewModel>;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
